export default __webpack_public_path__ + "static/media/glr-4.4773e0b8.webp";